export const IDLE_GAME_MODE = 'idle';
export const COLLECTING_GAME_MODE = 'collecting';
export const ANSWERING_GAME_MODE = 'answering';
export const EDITING_GAME_MODE = 'editing';
export const GAME_COMPLETED_MODE = 'completed';
export const GAME_TIME_UP_MODE = 'timeUp';

export const LETTERS = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'x',
    'y',
    'z',
];
export const RESET_GAME_ACTION = 'resetGame';
export const ADD_POINT_ACTION = 'addPoint';
export const ADD_WORD_ACTION = 'addWord';
export const REMOVE_WORD_ACTION = 'removeWord';
export const ENTER_COLLECTING_MODE_ACTION = 'enterCollectingMode';
export const ENTER_IDLE_MODE_ACTION = 'enterIdleMode';
export const ENTER_ANSWERING_MODE_ACTION = 'enterAnsweringMode';
export const ENTER_GAME_COMPLETE_ACTION = 'enterGameCompleteMode';
export const ENTER_EDITING_MODE_ACTION = 'enterEditingMode';
export const ENTER_GAME_TIME_UP_ACTION = 'enterTimeUpMode';
export const COLLECT_LETTER_ACTION = 'collectLetters';
export const CHECK_ANSWER_ACTION = 'checkAnswer';
export const MARK_WORD_AS_FOUND_ACTION = 'markWordAsFound';
export const SET_LETTERS_ACTION = 'setLetters';
export const MARK_LETTERS_AS_USED_ACTION = 'markLettersAsUsed';
export const REQUEST_CONFIRMATION_ACTION = 'requestConfirmation';
export const CANCEL_CONFIRMATION_ACTION = 'cancelConfirmation';

export const gap = 38;

export const WORDS_PER_LEVEL = 3;
export const MAX_LEVEL = 20;
export const FIRST_LEVEL_TIME = 240;
export const SECONDS_PER_WORD = 30;
